import React from 'react';
import { faFilm, faAward } from '@fortawesome/free-solid-svg-icons';
import { Bold, Paragraph, YellowCircleIcon, HoursAndMinutes, BorderT1 } from '../../Atoms';
import './OnlinePurchase.css';
import RegisterUser from '../../Atoms/RegisterUser/RegisterUser';

export const OnlinePurchase = ({ props, scheduler, parameters }) => {
  const certifiableHours = () => {
    const totalHorasCertificables = scheduler[0]?.course_duration?.hours;
    return totalHorasCertificables
      ? `${totalHorasCertificables} ${parameters?.TEXT_CERTIFIABLE_HOURS?.value}`
      : null;
  };

  return (
    <div className="ms-4 ps-1 ms-0 online-purchase__container">
      <section
        className=" d-flex mt-4 mx-auto flex-column justify-content-between border rounded-2"
        style={{ minHeight: '422px', maxWidth: '370px' }}>
        <Bold
          className="lt-card-title text-center mt-2 pb-0 mx-0"
          color="var(--corporative-yellow)">
          {parameters?.PD_WEB_LABEL?.value}
        </Bold>
        <div className="px-4">
          <div className={`d-flex justify-content-center align-items-center py-3`}>
            {props?.badgeImage && (
              <img
                className="img-fluid w-lg-100 w-50 py-lg-0"
                style={{ maxWidth: '55%', height: 'auto' }}
                alt="certificate student"
                src={props?.badgeImage}
              />
            )}
          </div>
          <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center align-items-center gap-4 mb-2">
            <div className="d-flex flex-column flex-wrap justify-content-center align-items-center gap-1">
              <YellowCircleIcon size="40px" colorIcon={'black'} icon={faFilm} />
              <div className="text-center">
                <Bold>{parameters?.CRS_DUR_LABEL?.value}</Bold>
                <Paragraph style={{ fontWeight: '600' }}>
                  <HoursAndMinutes
                    parameters={parameters}
                    duration={
                      scheduler[0]?.course_duration?.hours * 60 +
                      scheduler[0]?.course_duration?.minutes
                    }
                  />
                </Paragraph>
              </div>
            </div>
            <div className="d-flex  flex-column flex-wrap justify-content-center align-items-center gap-1">
              <YellowCircleIcon size="40px" colorIcon={'black'} icon={faAward} />
              <div className="text-center">
                <Bold>{parameters?.INF_MSG_123?.value}</Bold>
                <Paragraph style={{ fontWeight: '600' }}>
                  {parameters?.INF_MSG_123?.description_value}
                </Paragraph>
              </div>
            </div>
          </div>

          {certifiableHours() && (
            <div className="certifiableHours pb-3 mb-2">
              <BorderT1 className="mb-1 p-2 rounded">
                <Bold size="18px">{certifiableHours()}</Bold>
              </BorderT1>
            </div>
          )}
        </div>
      </section>
      <div
        style={{
          position: 'static',
          marginTop: '-31px',
          left: props?.isMobile
            ? '1%'
            : parameters?.GET_YOUR_CREDIT?.value?.toLowerCase() === 'true'
            ? '5%'
            : '5%',
          zIndex: 4
        }}
        className="d-flex gap-3 justify-content-center w-100">
        {parameters?.GET_YOUR_CREDIT?.value?.toLowerCase() === 'true' && (
          <RegisterUser
            disabled={props?.disabled}
            parameters={props?.parameters}
            setShowEnrrolmentForm={props?.setShowEnrrolmentForm}
          />
        )}

        <button
          type="button"
          aria-label="Submit button"
          onClick={() => props?.scrollToCourseMembership()}
          style={{
            height: '45px',
            borderRadius: '8px',
            background: 'var(--corporative-yellow)',
            opacity: '1',
            color: 'black',
            border: 'none'
          }}
          className={`btn m-0 btn-purchase mt-1`}>
          {parameters?.STUDY_PLAN?.value}
        </button>
      </div>
    </div>
  );
};
